import { Router, watchBusy } from "@frui.ts/screens/dist";
import { attachAutomaticValidator } from "@frui.ts/validation";
import type { interfaces } from "inversify";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { Modules } from "config";
import EnforcementTabletRepository from "repositories/enforcementTabletRepository";
import SecurityService from "services/securityService";
import EditableDetailViewModel from "../../editableDetailViewModel";
import EnforcementTabletResponse, { EnforcementTabletValidationRules } from "entities/enforcementTabletResponse";
import type UpdateEnforcementTabletRequest from "entities/updateEnforcementTabletRequest";
import { observable } from "mobx";

@Router.registerRoute({ route: ":tabletId", name: Router.Self })
export default class EnforcementTabletDetailViewModel extends EditableDetailViewModel<UpdateEnforcementTabletRequest> {
  readonly modelName = "enforcementTablet";
  @observable detail: EnforcementTabletResponse;

  constructor(
    protected itemId: string,
    private repository: EnforcementTabletRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    protected securityService: SecurityService
  ) {
    super(itemId);
  }

  @watchBusy
  protected async loadDetail() {
    const item = await this.repository.get(this.itemId);
    this.detail = item;
    attachAutomaticValidator(item, EnforcementTabletValidationRules);
    return item;
  }

  protected updateData() {
    return this.repository.update(this.itemId, this.item);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.enforcement, `enforcementTablets.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) => {
      return new EnforcementTabletDetailViewModel(
        itemId,
        container.get(EnforcementTabletRepository),
        container.get(LocalizationService),
        container.get(NotificationService),
        container.get(EventBus),
        container.get(SecurityService)
      );
    };
  }
}
